/*
  GENERAL ACTIONS
 */
export const RESET_STORE = 'RESET_STORE';

export const APP_STARTUP = 'APP_STARTUP';
export const APP_STARTUP_SUCCESS = 'APP_STARTUP_SUCCESS';
export const APP_STARTUP_FAILURE = 'APP_STARTUP_FAILURE';

export const APP_LOGIN = 'APP_LOGIN';
export const APP_LOGIN_SUCCESS = 'APP_LOGIN_SUCCESS';
export const APP_LOGIN_FAILURE = 'APP_LOGIN_FAILURE';

export const ERROR_MESSAGE = 'ERROR_MESSAGE';
export const SUCCESS_MESSAGE = 'SUCCESS_MESSAGE';
export const INFO_MESSAGE = 'INFO_MESSAGE';
